import type { ServiceError } from 'gpcore-apikit/grpc/types';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import type { BasicProject } from 'gpcore-grpc/gpcore/api/cloud/v1/project_pb';
import useNotifications from 'gpcore-uikit/composables/useNotifications';
import { ref } from 'vue';

export default () => {
  const projectStore = useProjectStore();

  const { addNotification } = useNotifications();

  const inviteDeclineProject = ref<BasicProject>();
  const inviteDeclineModalOpened = ref<boolean>(false);

  const resetInviteDecline = () => {
    inviteDeclineProject.value = null;
    inviteDeclineModalOpened.value = false;
  };

  const declineProject = (project: BasicProject) => {
    inviteDeclineProject.value = project;
    inviteDeclineModalOpened.value = true;
  };

  const isExecutingInviteDecline = ref<boolean>(false);
  const executeProjectInviteDecline = async () => {
    isExecutingInviteDecline.value = true;
    try {
      await projectStore.joinProject({
        projectId: inviteDeclineProject.value.id,
        accept: false,
      });
    } catch (error) {
      addNotification({
        type: 'danger',
        message: (error as ServiceError).message,
      });
    } finally {
      isExecutingInviteDecline.value = false;

      resetInviteDecline();
    }
  };

  const abortInviteDecline = () => {
    resetInviteDecline();
  };

  return {
    inviteDeclineProject,
    inviteDeclineModalOpened,
    declineProject,
    abortInviteDecline,

    executeProjectInviteDecline,
    isExecutingInviteDecline,
  };
};
